import { RelationSchema } from "$lib/data/schema/_relation"
import { RelationStrEmpty, RelationStrSchema } from "$lib/data/schema/_relation-str"
import { z } from "zod/v4"

export const OrderRelationSchema = RelationSchema.extend({ address: z.string().optional() })
export type Relation = z.infer<typeof OrderRelationSchema>

export const OrderItemSchema = z.object({
  id: z.number().default(0),
  ref_id: z.string().default(""),
  product_id: z.number().default(0),
  product_number: z.string().default(""),
  product_name: z.string().default(""),
  product: RelationSchema
    .extend({
      number: z.string().default("")
    })
    .optional(),
  quantity: z.number().default(0),
  unit: z.string().default(""),
  is_free: z.boolean().default(false),
  discount_percentage_raw: z.number().default(0),
  price_raw: z.number().default(0),
  discount_percentage: z.number().default(0),
  price: z.number().default(0),
  order: z.number().default(0),
  total: z.number().default(0),
  description: z.string().default(""),
})
export type OrderItem = z.infer<typeof OrderItemSchema>
export const OrderItemEmpty = OrderItemSchema.parse({})

export const OrderSchema = z.object({
  id: z.number().default(0),
  date: z.string().default(""),
  number: z.string().default(""),
  customer_number: z.string().default(""),
  customer: OrderRelationSchema.default(OrderRelationSchema.parse({})),
  amount: z.number().default(0),
  status: RelationStrSchema.default(RelationStrEmpty),
  description: z.string().optional(),
  date_start: z.string().default(""),
  date_end: z.string().default(""),
  type: RelationStrSchema.optional(),
  price_list_name: z.string().default(""),
  price_list_discount: z.number().default(0),
  total_sub: z.number().default(0),
  total_discount: z.number().default(0),
  total: z.number().default(0),
  total_paid: z.number().default(0),
  items: z.array(OrderItemSchema).default([]),
})
export type Order = z.infer<typeof OrderSchema>
export const OrderEmpty = OrderSchema.parse({})

export const ProductSchema = z.object({
  id: z.number().default(0),
  ref_id: z.string().default(""),
  number: z.string().default(""),
  name: z.string().default(""),
  contents: z.array(z.string()).default([]),
  discount_percentage: z.number().default(0),
  price_raw: z.number().default(0),
  price: z.number().default(0),
  unit: z.string().default(""),
  image_url: z.string().default(""),
  status: z.string().default(""),
  description: z.string().default(""),
})
export type Product = z.infer<typeof ProductSchema>
export const ProductEmpty = ProductSchema.parse({})

export const OrderFormSchema = z.object({
  id: z.number().default(0),
  action: z.string().default(""),
  date: z.string().default(""),
  number: z.string().default(""),
  type_id: z.string().default(""),
  type_name: z.string().default(""),
  customer_id: z.number().default(0),
  customer_name: z.string().default(""),
  customer_address: z.string().default(""),
  description: z.string().default(""),
  price_list_name: z.string().default("-"),
  price_list_discount: z.number().default(0),
  total_sub: z.number().default(0),
  total_discount: z.number().default(0),
  total: z.number().default(0),
  total_paid: z.number().default(0),
  status_id: z.string().default(""),
  status_name: z.string().default(""),
  items: z.array(OrderItemSchema).default([]),
})
export type OrderForm = z.infer<typeof OrderFormSchema>
export const OrderFormEmpty = OrderFormSchema.parse({})

export type OrderHistoryMode = "all" | "yoy"
export type OrderHistoryTax = "all" | "exc" | "inc"
export type OrderHistoryColumn = {
  type: "month" | "year"
  date: string
}
export type OrderHistoryProduct = {
  id: string
  number: string
  name: string
  unit: string
  values: number[]
  total: number
}
export type OrderHistoryGroup = {
  id: string
  name: string
  values: number[]
  total: number
  products: OrderHistoryProduct[]
}
export type OrderHistory = {
  units: string[]
  columns: OrderHistoryColumn[]
  values: number[]
  total: number
  groups: OrderHistoryGroup[]
}
